import React from 'react';

export default function Button({
  value = '',
  type = 'submit',
  isLoading = false,
  loadingValue = ''
}) {
  return (
    <button
      className={`py-3 rounded-full w-full text-white text-lg text-center ${
        isLoading
          ? 'bg-gray-400 cursor-not-allowed '
          : 'bg-lime-500 cursor-pointer'
      }`}
      type={type}
      disabled={isLoading}
    >
      {isLoading ? (
        <div className="flex justify-center items-center gap-2">
          <span className="loading loading-spinner loading-sm" />
          {loadingValue}
        </div>
      ) : (
        value
      )}
    </button>
  );
}
